module.exports = __webpack_public_path__ + "static/media/movi.8e211967.svg";